import styled from "styled-components";
import { Grid as MuiGrid } from "@material-ui/core";

export const PageContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
`;

export const PageWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1120px;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Container = styled(MuiGrid)`
  width: 100%;
  display: flex;
  justify-content: center;

  &.MuiGrid-spacing-xs-4 {
    margin: 0;
  }

  @media (min-width: 960px) {
    justify-content: space-between;
  }
`;
export const Grid = styled(MuiGrid)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Img = styled.img`
  width: 254px;
  height: 89px;

  @media (min-width: 960px) {
    width: 544px;
    height: auto;
  }
`;
